export function updateBillboardStyling() {
  const blocks = document.querySelectorAll('[data-block-type]');
  const header = document.getElementById('headerApp');


  if (blocks && blocks.length && header) {
    const blockType = blocks[0].dataset.blockType;
    if (blockType.includes('billboard') && ! header.classList.contains('header-bottom-border-active')) {
      header.classList.add('snug');
    }

    if (blockType.includes('billboard')) {
      const nightMode = blocks[0].dataset.nightMode;
      headerApp.dataset.darkBillboardBackground = nightMode;
    }
  }
}